import { ref } from "vue";

export const appName = "Баласка";
export const appTitle = `Инфографика по территориям вывоза мусора <b>${appName}</b>`;

export const balanceWarning = 20;
export const balanceBlock = 10;

export const app_android = ref(
  "https://play.google.com/store/apps/details?id=ru.balaska"
);
export const app_apple = ref(
  "https://apps.apple.com/ru/app/баласка-вывоз-мусора-balaska/id6477859873"
);

export const app_rustore = ref("https://www.rustore.ru/catalog/app/ru.balaska");
